import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFolderStore = defineStore('folder', () => {
  const currentFolder = ref(null);

  const {
    items: folders,
    fetchItems: fetch,
    storeItem: store,
    updateItem: update,
    destroyItem: destroy,
  } = createBaseStore('api/assets/folder');

  const fetchForSpace = async (space) => {
    const overrideUrl = `/api/assets/folder?space=${space}`;
    return await fetch(null, overrideUrl);
  };

  return {
    folders,
    currentFolder,
    fetch,
    destroy,
    update,
    store,
    fetchForSpace,
  };
});
